import React from "react";
import { useSearchParams } from "react-router-dom";
import { isWebView } from "../../utlis/webViewBridge";
import useT from "../../i18n/useT";
import "./AppReportToolbar.scss";

export const APP_PREVIEW_PARAM = "appPreview";

export const addAppPreviewMarker = (url) => {
  if (!url) return "";
  const markedUrl = new URL(url, window.location.origin);
  markedUrl.searchParams.set(APP_PREVIEW_PARAM, "1");
  return markedUrl.href;
};

const AppReportToolbar = () => {
  const [searchParams] = useSearchParams();
  const t = useT("common");
  if (searchParams.get(APP_PREVIEW_PARAM) !== "1" || !isWebView()) return null;

  const closeReport = () => {
    const canGoBack = (window.history.state?.idx ?? 0) > 0;

    // Works for a normal browser tab opened by Preview. Some WebViews ignore
    // window.close(), so fall back to SPA/browser history and finally the app
    // root (which restores the last non-report URL).
    window.close();
    window.setTimeout(() => {
      if (canGoBack || window.history.length > 1) {
        window.history.back();
      } else {
        window.location.replace("/");
      }
    }, 100);
  };

  return (
    <div className="app-report-toolbar">
      <button
        type="button"
        onClick={closeReport}
        aria-label={t("close_report")}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M19 12H5m7-7-7 7 7 7" />
        </svg>
        <span>{t("back_to_app")}</span>
      </button>
      <strong>{t("report_preview")}</strong>
    </div>
  );
};

export default AppReportToolbar;
